import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TrendingYoutubeInfluencersV2.graphql';
import { Query, QuerytrendingYoutubeInfluencersV2Args } from '../../__generated__/globalTypes';

export const useTrendingYoutubeInfluencersV2Query = (
  options?: QueryHookOptions<Query, QuerytrendingYoutubeInfluencersV2Args>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytrendingYoutubeInfluencersV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTrendingYoutubeInfluencersV2LazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytrendingYoutubeInfluencersV2Args>
): QueryResult<Query, QuerytrendingYoutubeInfluencersV2Args> & {
  getTrendingYoutubeInfluencersV2: LazyQueryExecFunction<Query, QuerytrendingYoutubeInfluencersV2Args>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTrendingYoutubeInfluencersV2, result] = useLazyQuery<Query, QuerytrendingYoutubeInfluencersV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTrendingYoutubeInfluencersV2, ...result };
};

export const useTrendingYoutubeInfluencersV2PromiseQuery = () => {
  const client = useApolloClient();

  const getTrendingYoutubeInfluencersV2 = useCallback(
    (options?: Omit<QueryOptions<QuerytrendingYoutubeInfluencersV2Args, Query>, 'query'>) =>
      client.query<Query, QuerytrendingYoutubeInfluencersV2Args>({ ...options, query: QUERY }),
    [client]
  );

  return { getTrendingYoutubeInfluencersV2 };
};
// Suspense Query Hooks
export const useTrendingYoutubeInfluencersV2SuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytrendingYoutubeInfluencersV2Args>
) => {
  const result = useSuspenseQuery<Query, QuerytrendingYoutubeInfluencersV2Args>(QUERY, {
    ...options
  });

  return result;
};
